import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopMembers } from 'src/services/Scope.client';

export type Mode = 'light' | 'dark';

export interface SettingsState {
  isCompanionCollapsed: boolean;
  lastScopeCreated: Record<string, TopMembers>;
  isMfpPivotCollapsed: boolean;
  isMfpMacroSummariesCollapsed: boolean;
  themeMode: Mode;
  matchBrowserTheme: boolean;
}
const initialState: SettingsState = {
  isCompanionCollapsed: false,
  lastScopeCreated: {} as Record<string, TopMembers>,
  isMfpPivotCollapsed: false,
  isMfpMacroSummariesCollapsed: false,
  themeMode: 'light',
  matchBrowserTheme: false,
};

const uiPoseSlice = createSlice({
  name: 'uiPose',
  initialState: initialState,
  reducers: {
    setLastScopeCreated: (state, action: PayloadAction<[string, TopMembers]>) => {
      state.lastScopeCreated[action.payload[0]] = action.payload[1];
    },
    toggleCompanionCollapse: (state) => {
      state.isCompanionCollapsed = !state.isCompanionCollapsed;
    },
    setMfpPivotCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isMfpPivotCollapsed = action.payload;
    },
    setMfpMacroSummariesCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isMfpMacroSummariesCollapsed = action.payload;
    },
    setThemeMode: (state, action: PayloadAction<Mode>) => {
      state.themeMode = action.payload;
    },
    toggleMode: (state) => {
      state.matchBrowserTheme = false;
      state.themeMode = state.themeMode === 'dark' ? 'light' : 'dark';
    },
    toggleMatchBrowserTheme: (state) => {
      state.matchBrowserTheme = !state.matchBrowserTheme;
    },
  },
});

export const {
  setLastScopeCreated,
  toggleCompanionCollapse,
  setMfpPivotCollapsed,
  setMfpMacroSummariesCollapsed,
  setThemeMode,
  toggleMode,
  toggleMatchBrowserTheme,
} = uiPoseSlice.actions;

export default uiPoseSlice.reducer;
